import { CIcon } from '~/icons/types'
export const ciAutoTouch: CIcon = {
  width: 512,
  height: 512,
  paths: [
    {
      d:
        'M512 127.8 453.5 146C431.1 102.4 396 66.7 351.7 43.5c-56.8-29.8-121.8-35.7-183-16.6-61.2 19-111.3 60.8-141.1 117.5C-2.2 201.2-8.1 266.1 11 327.3c19 61.2 60.8 111.4 117.5 141.2 34.9 18.3 72.9 27.6 111.3 27.6 24 0 48.1-3.6 71.6-11 33.8-10.5 64-27.8 90-51.4 12.9-11.8 13.9-31.8 2.1-44.7-11.8-12.9-31.8-13.9-44.7-2.1-19.1 17.4-41.4 30.1-66.2 37.8-45 14-92.9 9.7-134.6-12.3-41.8-21.9-72.5-58.8-86.5-103.9-29-93 23.1-192.2 116.1-221.2 45-14 92.9-9.7 134.6 12.3 29.2 15.3 53 38 69.5 65.7L341.3 181l131.4 121.3L512 127.8z'
    },
    {
      d:
        'm213 119.5-31.7 39.7v140.6c0 2.6.3 5.1.9 7.6.9 3.6 2.4 7 4.4 10.1 0 0 0 .1.1.1l.6.9c.1.1.2.3.3.4.1.2.3.4.5.6s.3.4.5.7c.1.1.2.2.2.3.3.3.5.6.8.9 2.5 2.8 5.6 5.2 9.1 6.9 2.1 1.1 4.4 2 6.8 2.5l98.5 24.6c2.6.6 7.7 1 7.7 1l39.7-25-32-37.4-74.6-18.7v-116L213 119.5z'
    }
  ],
  name: 'auto-touch',
  type: 'solid'
}
